import { render, staticRenderFns } from "./EditionSidebar.vue?vue&type=template&id=5e627fc1&"
import script from "./EditionSidebar.vue?vue&type=script&lang=ts&"
export * from "./EditionSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports